export enum $sso {
  audience = 'audience',
  idpClientId = 'idpClientId',
  idpDomain = 'idpDomain',
}

export const MANDATORY_FIELDS: $sso[] = [$sso.audience, $sso.idpDomain, $sso.idpClientId];

export const CHAR_LIMITS: Readonly<Record<$sso, number>> = Object.freeze({
  [$sso.audience]: 200,
  [$sso.idpClientId]: 200,
  [$sso.idpDomain]: 200,
});
